import React, { useContext } from "react";
import { Fade, Slide } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
// import "../skills/Skills.css";
import Tilt from "react-parallax-tilt";
import {  aboutSection } from "../../portfolio";
import "./About.css";

const About = () => {
  const { isDark } = useContext(StyleContext);

  return (
    <div className={isDark ? "dark-mode main" : "main"} id="about">
      <div className="about-main-div">
        <Fade left duration={1000}>
          <div className="about-image-div">
            <Tilt scale={0.9} transitionSpeed={3000}>
              <img
                alt="Man Working"
                src={require("../../assets/images/1619810675986-removebg-preview.png")}
                style={{ width: "100%" }}
              />
            </Tilt>
          </div>
        </Fade>
        <Fade right duration={1000}>
          <div className="about-text-div">
          <Slide right duration={2000}>
              <div className="about-border"></div>
            </Slide>
            <h1
              className={isDark ? "dark-mode about-heading" : "about-heading"}
            >
              {aboutSection.title}{" "}
            </h1>
            
            <p
              className={
                isDark
                  ? "dark-mode subTitle about-text-subtitle"
                  : "subTitle about-text-subtitle"
              }
            >
              {aboutSection.subTitle}
            </p>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default About;
